export default class NewsDetailsResponse {
    constructor(data = null, supportedLocales = []) {
        this.translations = [];
        this.coinsToEarn = null;
        this.createDate = null;
        this.activeFrom = null;
        this.activeTo = null;
        this.id = null;
        this.status = null;
        this.image = '';
        this.iconTemporaryFileUrl = '';
        this.publishedToCompanies = [];
        
        if (data) {
            this.id = data.id;
            this.coinsToEarn = data.coinsToEarn;
            this.createDate = data.createDate;
            this.image = data.image;
            this.activeFrom = data.activeFrom ? new Date(data.activeFrom) : null;
            this.activeTo = data.activeTo ? new Date(data.activeTo) : null;
            this.iconTemporaryFileUrl = data.iconTemporaryFileUrl;
            this.status = data.status;
            this.publishedToCompanies = data.publishedToCompanies || [];

            supportedLocales?.forEach((element) => {
                this.translations[element] = {
                    title: data.translations[element]?.title || '',
                    description: data.translations[element]?.description || '',
                };
            });
        }
    }
}
